import V2SettlePnlHistoryTable from 'src/components/HistoryTables/V2SettlePnlHistoryTable';
import PortfolioHistorySettledTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistorySettledTable/PortfolioHistorySettledTableControls';

export default function PortfolioHistorySettledTable() {
	return (
		<div>
			<PortfolioHistorySettledTableControls />
			<V2SettlePnlHistoryTable />
		</div>
	);
}
